import {REFUND_URLS} from './urlMapping';

const getRefundUrl = (scopes = []) => {
    const filteredScopes = scopes.filter((scope) => scope === 'ais' || scope === 's2e');

    switch (filteredScopes.length) {
        case 1:
            return REFUND_URLS.ONE_SCOPE[filteredScopes[0]] || null;
        case 2:
            return REFUND_URLS.TWO_SCOPES;
        default:
            return null;
    }
};

export default getRefundUrl;
